
export const sanitizePhoneNumber = (phoneNumber) => {
    if (!phoneNumber || typeof phoneNumber !== "string") {
      console.warn("sanitizePhoneNumber called with invalid input:", phoneNumber);
      return "";  // Return an empty string if input is invalid
    }
  
    // Keep the leading '+' if it exists and remove all other non-numeric characters
    return phoneNumber.replace(/(?!^\+)[^\d]/g, "");
  };
 
  

export const sanitizeAmount = (amount) => {
    // Ensure amount is a string
    if (typeof amount !== 'string') {
        throw new Error('Amount must be provided as a string.');
    }
    
    // Remove commas and trim whitespace
    amount = amount.replace(/,/g, '').trim();
    
    // Regular expression to validate the amount format
    const regex = /^0(?:\.\d{1,2})$|^[1-9]\d{0,17}(?:\.\d{1,2})?$/;
    
    // Validate the amount format
    if (!regex.test(amount)) {
        throw new Error('Invalid amount format.');
    }
    
    // Normalize the amount: remove leading zeros and unnecessary decimal places
    let normalizedAmount = parseFloat(amount).toString();
    
    // If the original amount was intended to have a decimal part but was stripped (e.g., "5.00"),
    // append ".0" or ".00" to match the original intention if needed.
    const decimalPart = amount.split('.')[1];
    if (decimalPart && normalizedAmount.indexOf('.') === -1) {
        if (decimalPart.length === 1) {
            normalizedAmount += ".0"; // Append ".0" if there was one decimal place
        } else if (decimalPart.length >= 2) {
            normalizedAmount += ".00"; // Append ".00" for two decimal places
        }
    }

    return normalizedAmount;
}

export const generateId  = () => {
    return uuidv4();
}

export const getAuthHeaders = (apiKey) => {
    return {
        'Authorization': `Bearer ${apiKey}`,
        'Content-Type': 'application/json'
    };
}